import { render, staticRenderFns } from "./AssetManagement.vue?vue&type=template&id=5e4e6dcc&scoped=true"
import script from "./AssetManagement.vue?vue&type=script&lang=js"
export * from "./AssetManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e6dcc",
  null
  
)

export default component.exports